module.exports = __webpack_public_path__ + "img/9788996373742.5f4cde0d.jpg";